import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Typography, Grid, MuiThemeProvider } from "@material-ui/core";

class DisplayGameObject extends Component {
  render() {
    const { lastRoundData, theme} = this.props;

    if (lastRoundData === null || lastRoundData === undefined)
    {
      return <div></div>;
    }

    return (
      <MuiThemeProvider theme={theme}>
        <Grid container style={{ textAlign: "center" }}>
          {lastRoundData.type === "prompt" ? (
            <Grid item xs={12}>
              <Typography variant="h6" color='primary'>{lastRoundData.data}</Typography>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <img style={{width: 300, height: 500, backgroundColor: 'lightgrey' }} src={lastRoundData.data ? URL.createObjectURL(new Blob([lastRoundData.data])) : ""} alt="" />
            </Grid>
          )}
        </Grid>
      </MuiThemeProvider>
    );
  };
};

const styles = theme => ({});

export default withStyles(styles)(DisplayGameObject);
